module.exports = __webpack_public_path__ + "static/media/zeya_walking_01.8e646de4.png";